module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "datatable"
  }, [_c('table', {
    class: _vm.table_class
  }, [_c('tbody', [_vm._l((_vm.columns), function(col, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      class: _vm.name_class
    }, [_vm._v(_vm._s(_vm.$t(col.name)))]), _vm._v(" "), _c('td', [_c('div', {
      attrs: {
        "child_class": _vm.child_class
      }
    }, [_vm._t(col.id, function() {
      return [_vm._v(_vm._s(_vm.$t(col.name)))]
    })], 2)])])
  }), _vm._v(" "), _c('tr', [_vm._t("tfooter")], 2)], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-045a0d26","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VerticalTable.vue
// module id = 478
// module chunks = 1